<form [formGroup]="form">

  <a
    href="javascript:void(0)"
    class="dropzone"
    [class.dropzone--active]="isDragging"
    [class.dropzone--has-file]="selectedFile"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()">

    <input
      #fileInput
      type="file"
      accept=".csv"
      class="hidden"
      (change)="onFileSelected($event)" />

    @if (selectedFile) {
      <div class="dropzone__file">
        <svg xmlns="http://www.w3.org/2000/svg" class="dropzone__file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
        <span class="dropzone__file-name">{{ selectedFile.name }}</span>
        <span class="dropzone__file-size">{{ formatFileSize(selectedFile.size) }}</span>
        <button type="button" class="dropzone__remove" (click)="removeFile($event)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      </div>
    } @else {
      <div class="dropzone__prompt">
        <svg xmlns="http://www.w3.org/2000/svg" class="dropzone__upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
        </svg>
        <p class="dropzone__label">
          {{ 'meteringpoint.csvupload.dropzone.label' | translate }}
        </p>
        <p class="dropzone__sublabel">
          {{ 'meteringpoint.csvupload.dropzone.sublabel' | translate }}
        </p>
      </div>
    }
  </a>

  @if (fileError) {
    <p class="mt-1 text-sm text-red-600">{{ fileError }}</p>
  }

  <app-input-group class="mt-4 block">
    <label class="ec-toggle-label">
      {{ 'meteringpoint.timeseries.submit.wantslocked' | translate }}
      <app-toggle formControlName="shouldBeLocked"></app-toggle>
    </label>
  </app-input-group>

</form>
